import { useRecoilValue } from 'recoil'
import { useMemo } from 'react'
import { IProjectTechnogy } from '../../projectTechnologies.types'
import projectTechnologiesAtom from '../../projectTechnologies.atom'
import Dropdown from 'shared/Inputs/Dropdown'

interface IProps {
  name?: string
  value: IProjectTechnogy['id']
  onChange: (val: IProjectTechnogy['id'], name: string) => void
}

const ProjectTechnologiesDropdown = (props: IProps) => {
  const events = useRecoilValue(projectTechnologiesAtom).items

  const options = useMemo(() => {
    return events.map((e) => ({ title: e.title, value: e.id }))
  }, [events])

  const onChange = (option: { title: string; value: number }, name: string) => {
    props.onChange(option?.value ?? null, name)
  }

  const selected = useMemo(() => {
    return options.find((o) => o.value === props.value) || null
  }, [props.value, options])

  return (
    <Dropdown
      options={options}
      selectedOption={selected}
      title='Ключевая технология'
      onSelect={onChange}
      name={props.name}
      getOptionKey={(o) => o?.value}
      getOptionLabel={(o) => o?.title}
    />
  )
}

export default ProjectTechnologiesDropdown
